/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Previous_PeriodInputs */

const en_usage_previous_period = /** @type {(inputs: Usage_Previous_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous Period`)
};

const fr_usage_previous_period = /** @type {(inputs: Usage_Previous_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Période précédente`)
};

const de_usage_previous_period = /** @type {(inputs: Usage_Previous_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vorherige Periode`)
};

const it_usage_previous_period = /** @type {(inputs: Usage_Previous_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodo precedente`)
};

const ru_usage_previous_period = /** @type {(inputs: Usage_Previous_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предыдущий период`)
};

const es_usage_previous_period = /** @type {(inputs: Usage_Previous_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodo anterior`)
};

const zh_cn2_usage_previous_period = /** @type {(inputs: Usage_Previous_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上期`)
};

const ja_usage_previous_period = /** @type {(inputs: Usage_Previous_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前期`)
};

const hi_usage_previous_period = /** @type {(inputs: Usage_Previous_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछली अवधि`)
};

const pt_pt2_usage_previous_period = /** @type {(inputs: Usage_Previous_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Período anterior`)
};

/**
* | output |
* | --- |
* | "Previous Period" |
*
* @param {Usage_Previous_PeriodInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_previous_period = /** @type {((inputs?: Usage_Previous_PeriodInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Previous_PeriodInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_previous_period(inputs)
	if (locale === "de") return de_usage_previous_period(inputs)
	if (locale === "it") return it_usage_previous_period(inputs)
	if (locale === "ru") return ru_usage_previous_period(inputs)
	if (locale === "es") return es_usage_previous_period(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_previous_period(inputs)
	if (locale === "ja") return ja_usage_previous_period(inputs)
	if (locale === "hi") return hi_usage_previous_period(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_previous_period(inputs)
	return en_usage_previous_period(inputs)
});